module.exports = __webpack_public_path__ + "img/screenshot (6).8ff9aba1.jpg";